<template lang="pug">
  #form
    v-row(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-center.mt-5.pt-5 ¿Estás seguro de que quieres borrar este folio?
            v-spacer.mt-4
            v-row.px-5.mb-5
              v-col.d-flex.justify-end( justify-end xs=6 sm=6 )
                v-btn.main-background.bold(text @click.native="dialog = false") CANCELAR
              v-col.d-flex.justify-start(d-flex xs=6 sm=6)
                v-btn.main-background.bold(text @click.native="deleteReport") ELIMINAR FOLIO
    Header
    v-container.pl-0(fluid)
      v-row.all
        v-col(xs=2 sm=2)
          v-row
            Side
        v-col(xs=10 sm=10)
          v-row
            v-col.postal(xs=12 sm=12 md=6 lg=6)
              v-row
                v-col#top(xs=6 sm=6)
                  .form-title.main-text.light Postal Uno
                v-col(xs=6 sm=6 v-if="user.role === 'admin'")
                  v-row
                    v-col(xs=4 sm=4)
                      p.text-xs-center Folio Privado
                    v-col(xs=1 sm=1)
                      v-switch(color="#462979" v-model="public")
                    v-col(xs=4 sm=4)
                      p.text-xs-center Folio Público
              v-row
                VictimPostal(v-bind:victimData="victims[0]")
              v-row
                MiniPostal(v-bind:victimData="victims[0]")
              //v-row(v-if="showVictim" v-for="(victim, index) in victims" :key="index")
                VictimPostal(v-bind:victimData="victim")
            v-col.container.postal-form(xs12 sm12 md5 lg5)
              v-row
                VictimData
              v-row
                Contact
              //v-row(v-if="showVictim" v-for="(victim, index) in victims" :key="index")
                v-row.container
                  v-col(xs=6 sm=6)
                    h1.form-title2.accent-text Datos de la víctima
                Victim(v-bind:victimData="victim")
              //v-row.add-button(row wrap justify-space-between v-if="showVictim")
                v-col.btn-h(xs=6 sm=6)
                  v-btn(outline fab color="#4a4a4a" v-on:click="addVictim")
                    v-icon add
                  p Agregar víctima

          v-divider.form.my-4
          #narrative-summary
          v-tabs(:centered="false")
            v-tab
              p.bold.tab-text Relatoria
            v-tab
              p.bold.tab-text Resumen ejecutivo
            v-tab-item
              Narrative
            v-tab-item
              Summary

          v-divider.form.my-4
          v-row(v-if="isEditing" row wrap)
            v-col(xs=12 sm=12)
              Updates
          v-divider.form.my-4(v-if="isEditing")
          v-row(v-if="isEditing" row wrap)
            v-col(xs=12 sm=12)
              Edit
          v-row(justify="space-between")
            v-col(xs=6 sm=6 justify="start")
              v-btn.main-background.bold(v-if="userPermissions.deleteReports && isEditing" v-on:click="openDialog") Eliminar este folio
            v-col.edit-buttons(xs=6 sm=6)
              v-btn.main-background.bold.mr-4.go-to(to="/") Cancelar
              v-btn.main-background.bold.ml-4(v-if="!isEditing", v-on:click="createReport") Guardar
              v-btn.main-background.bold(v-if="isEditing", v-on:click="updateReport") Guardar

</template>

<script>
import * as d3 from "d3";
import * as html2canvas from "html2canvas";
import * as _ from "lodash";
import Header from "@/components/Header.vue";
import Side from "@/components/Side.vue";
import VictimPostal from "@/components/Postal/VictimPostal.vue";
import MiniPostal from "@/components/Postal/MiniPostal.vue";
import VictimData from "@/components/Form/VictimData.vue";
import Contact from "@/components/Form/Contact.vue";
import Narrative from "@/components/Form/Narrative.vue";
import Summary from "@/components/Form/Summary.vue";
import Updates from "@/components/Updates.vue";
import Edit from "@/components/Edit.vue";

export default {
  name: "Form",
  props: {},
  components: {
    Header,
    Side,
    VictimPostal,
    MiniPostal,
    VictimData,
    Contact,
    Narrative,
    Summary,
    Updates,
    Edit
  },
  data() {
    return {
      dialog: false,
      user: this.$store.state.user,
      wrongAge: false,
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    record() {
      return this.$store.getters.record;
    },
    isEditing() {
      let edit = this.$store.state.editing;
      return edit;
    },
    /*showVictim() {
      return this.$store.state.showVictim;
    },*/
    victims() {
      const selectedVictims = _.orderBy(
        this.$store.state.record,
        ["folio"],
        ["asc"]
      );
      return selectedVictims;
    },
    public: {
      get() {
        return this.$store.state.record.public;
      },
      set(value) {
        this.$store.state.record.public = value;
      }
    }
  },
  methods: {
    handleError(phase, error, notification) {
      console.log("Error while " + phase, error);
      this.$store.commit("setShowNotification", {
        type: "error",
        title: "ERROR",
        text: notification
      });
      this.$store.commit("setIsLoadingState", false);
      //this.$router.replace("/");
    },
    async updatefiles() {
      // UpdateCsv request
      this.updateCsv();

        // Get victim image from S3
        let imageFile;
        if (this.record.victimData.photo.startsWith("https://s3.amazonaws.com/")) {
          let fetchResponse = await fetch(this.record.victimData.photo.replace(/\?.*$/, ""))
          let blob = await fetchResponse.blob();
          let file = new File([blob], "test.jpg");
          imageFile = await this.getBase64(file);
        } else {
          imageFile = "static/upload-icon.png";
        }
      // Upload Postal Image
      try {
        let imageFile;
        let postalResponse = await this.uploadImage(
          this.record.folio, // folio
          "#postal-victim", // element
          "postal-victima", // image type
          this.record.folio, // naming
          imageFile // extra image for canvas
        );

        this.$store.commit("setShowNotification", {
          type: "success",
          title: "POSTAL GUARDADA CON ÉXITO",
          text: postalResponse.message
        });
      } catch (err) {
        this.handleError("postal uploading", err, "Error al crear postal principal");
        return;
      }

      // Upload Mini Postal Image
      try {
        let imageFile;
        let miniPostalResponse = await this.uploadImage(
          this.record.folio, // folio
          "#mini-postal", // element
          "mini-postal", // image type
          "mini-postal-" + this.record.folio, // naming
          imageFile // extra image for canvas
        );

        this.$store.commit("setShowNotification", {
          type: "success",
          title: "POSTAL RESUMIDA GUARDADA CON ÉXITO",
          text: miniPostalResponse.message
        });
      } catch (err) {
        this.handleError("mini postal uploading", err, "Error al crear postal resumida");
        return;
      }
      //console.info('bjhbcjhsdbcds', this.$store.state.record);
    },
    async createReport() {
      console.log(this.$store.state.record, "CREATE");

      this.$store.commit("setIsLoadingState", true);
      try {
        let responseCreateReport = await this.$store.dispatch("createReport")

        if (responseCreateReport.status == 403) {
          this.$router.replace("/login");
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "ERROR",
            text: responseCreateReport.message
          });
          return;
        }

        this.$store.commit("setShowNotification", {
          type: "success",
          title: "REGISTRO REALIZADO CON ÉXITO",
          text: responseCreateReport.data.message
        });

        this.record._id = responseCreateReport.data.result["_id"];
        this.record.folio = responseCreateReport.data.folio;

      } catch (err) {
        this.handleError("creatingReport", err, "Error al crear el reporte");
        return;
      }

      await this.updatefiles();
      await this.policeReportFiles();
      await this.$store.dispatch("initAllForms");
      this.$router.replace("/");
      this.$store.commit("setIsLoadingState", false);
    },
    async updateReport() {
      if (this.record._id === "" || typeof this.record._id === "undefined") {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/");
      } else {
        this.$store.commit("setIsLoadingState", true);

        try {
          const response = await this.$store.dispatch("updateReport");

          if (response.status == 403) {
            this.$router.replace("/login");
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("setShowNotification", {
              type: "error",
              title: "ERROR",
              text: response.message
            });
            return;
          }

          this.$store.commit("setShowNotification", {
            type: "success",
            title: "REGISTRO ACTUALIZADO CON ÉXITO",
            text: response.data.message
          });
        } catch (error) {
          console.log(error);
          this.handleError("update report", error, "Error al actalizar la información")
        }
          //console.log(this.$store.state.record, "update");

          await this.updatefiles();
          await this.policeReportFiles();
          await this.$store.dispatch("initAllForms");
          this.$router.replace("/");
          this.$store.commit("setIsLoadingState", false);

      }
    },
    deleteReport() {
      this.dialog = false;
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteReport")
        .then(response => {
          if (response.status == 200) {
            this.$store.commit("setShowNotification", {
              type: "success",
              title: "ÉXITO",
              text: response.data.message
            });
            this.$store.dispatch("initAllForms");
            this.$router.replace("/");
            this.$store.commit("setIsLoadingState", false);

            // UpdateCsv request
            this.updateCsv();
          } else if (response.status == 403) {
            this.$router.replace("/login");
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("setShowNotification", {
              type: "error",
              title: "ERROR",
              text: response.message
            });
          }
        })
        .catch(error => {
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
          this.$store.commit("setIsLoadingState", false);
        });
    },
    async policeReportFiles() {
      try {
        this.$store.state.record.narrative.policeReports.forEach(report => {
          if (report.formData.length > 0 ) {
            report.formData.set('folio', this.record.folio);
            this.$store.dispatch("uploadFile", report.formData);
          }
        })

        this.$store.commit("setShowNotification", {
          type: "success",
          title: "ARCHIVO GUARDADO CON ÉXITO",
          text: "OK"
        });
      }
      catch(err) {
        this.handleError("police report file uploading", err, "ERROR AL CARGAR DOCUMENTO");
      }
    },
    uploadImage(folio, element, description, name, url) {
      return new Promise(async (resolve, reject) => {
        try {
          let imageElement = await d3.select(element).node();
          let canvas = await html2canvas(imageElement);
          //console.log(imageElement,canvas,'image');

          let imageData = {
            folio: folio,
            file: canvas.toDataURL("image/jpeg"),
            descrip: description,
            fileName: name
          };

          if (url) {
            var ctx = canvas.getContext("2d");
            var img = new Image();

            img.src = url;

            const imageSize = d3.select(element + " img").node().getBoundingClientRect();
            //console.log(img, "CANVAS", url);
            img.onload = () => {
              //console.log("load")
              ctx.drawImage(img, 130, 370, 300.33, imageSize.height * 3.4);
              imageData.file = canvas.toDataURL("image/jpeg");
              //console.log(canvas, imageData);
              this.$store
                .dispatch("uploadImage", imageData)
                .then(response => {
                  return resolve(response.data);
                })
                .catch(error => {
                  return reject(error);
                });
            };
          } else {
            //console.log('upload function', imageData);
            return this.$store
              .dispatch("uploadImage", imageData)
              .then(response => {
                return resolve(response.data);
              })
              .catch(error => {
                return reject(error);
              });
          }
        } catch (err) {
          return reject(err);
        }
      });
    },
    updateCsv() {
      this.$store.dispatch("updateCsv")
        .catch(error => {
          this.handleError("Error while updating csv: ", error, "Error al actualizar el csv");
        });
    },
    validateVictims() {
      let validation = [];
      if (this.showVictim) {
        _.forEach(this.victims, v => {
          _.forEach(v, (val, key) => {
            if ((!val || val === "") && key !== "photo") {
              validation.push(false);
              this.wrongAge = key === "age" ? true : false;
            }
          });
        });
      }

      return validation.length > 0 ? false : true;
    },
    validateMultipleOptions(obj) {
      let boolSelection = [];
      _.forEach(obj, val => {
        if (val.isSelected) {
          boolSelection.push(val.text);
        }
      });
      return boolSelection.length > 0 ? false : true;
    },
    addVictim() {
      this.$store.dispatch("updateVictims", {
        operation: "add",
        currentFolio: this.victims.length
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    openDialog() {
      this.dialog = true;
    }
  },
  async mounted() {
    if (!this.$route.path.includes('edit')) await this.$store.dispatch("initAllForms");
  }
};
</script>

<style scoped lang="scss">
.all {
  max-width: 1900px;
}
p.headline {
  color: #4361ee;
  font-size: 30px !important;
  font-stretch: condensed;
  font-weight: 600;
}
.postal {
  min-width: 570px;
}
.postal-form {
  padding: 0px;
}
.btn--outline {
  width: 26px;
  height: 26px;
}
.btn-h {
  display: flex;
  align-items: center;
}
.end {
  justify-content: flex-end;
  padding-right: 15px;
}
.icon {
  font-size: 20px;
  margin-bottom: 1px;
}
.edit-buttons {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  .btn {
    float: right !important;
  }
}
</style>
